import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DataPilotInfoService} from '../../utils/data-services/data-pilot-info.service';
import swal from 'sweetalert2';
import {DataCreationConcessionService} from '../../utils/data-services/dataCreation-concession.service';
import {DataConcessionService} from '../../utils/data-services/dataConcession.service';

@Component({
  selector: 'app-form-pilot-info',
  templateUrl: './form-pilot-info.component.html',
  styleUrls: ['./form-pilot-info.component.scss']
})
export class FormPilotInfoComponent implements OnInit {

  elementId = null;
  contentDb = null;
  brandArray = [];
  dealershipArray = [];
  dealershipList = [];
  value = '';
  startAt = new Date();
  endAt = null;
  brand = 'BMW';
  dealership = null;
  errorMessage = '';
  dateNow = new Date();

  contentSrc: any = '';
  fileNameFullsize = '';
  fileData = null;

  constructor(
    private activeRoute: ActivatedRoute,
    private route: Router,
    private pilotInfoService: DataPilotInfoService,
    private dataCreationConcessionService: DataCreationConcessionService,
    private dataConcessionService: DataConcessionService,
  ) { }

  ngOnInit() {
    this.elementId = Number(this.activeRoute.snapshot.paramMap.get('id'));
    this.getBrands();
    this.getDealerships();
    if (this.elementId) {
      this.pilotInfoService.getById(this.elementId).subscribe(res => {
        this.contentDb = res;
        this.value = res.value;
        this.startAt = new Date(res.startAt);
        this.endAt = res.endAt ? new Date(res.endAt) : null;
        this.brand = res.brand;
        this.dealership = res.dealership;
        this.getImage();
      });
    }
  }
  getBrands() {
    this.dataCreationConcessionService.getBrands().subscribe(brands => {
      this.brandArray = brands.records.filter(x => x.marque_id != 1);
    });
  }
  getDealerships() {
    this.dataConcessionService.getConcession().subscribe(dealership => {
      this.dealershipArray = dealership.records;
      this.dealershipList = dealership.records;
      if (!this.elementId) {
        this.dealership = dealership.records[0].concession_id;
      }
    });
  }
  filterDealership(event): any {
    event.stopPropagation();
    const regexp = new RegExp(event.target.value.toLowerCase());
    this.dealershipArray = this.dealershipList.filter(x => {
      return regexp.exec(x.nom_concession.toLowerCase());
    });
  }
  onValidation(): boolean {
    if (this.value == '') {
      this.errorMessage = 'Veuillez renseigner le contenu de l\'information';
      return true;
    } else {
      this.errorMessage = '';
      return false;
    }
  }
  uploadImage(fileInputEvent): any {
    const file = fileInputEvent.target.files[0];
    if (!file.type.split('/').includes('jpg') && !file.type.split('/').includes('jpeg') && !file.type.split('/').includes('png')) {
      swal.fire({
        title: 'Attention',
        text: 'Fichier incompatible. Le fichier doit être de type jpeg, jpg ou png.',
        type: 'error',
        confirmButtonText: 'Ok',
      });
    } else if ((file.size / 1048576) <= 5) { // max file size is 5 mb
      const formData = new FormData();
      formData.append('file', file, file.name);
      const info = {
        concession_id: this.dealership,
        file_size: file.size,
        file_type: file.type,
        uploaded_by: sessionStorage.getItem('userName'),
      };
      formData.append('info', JSON.stringify(info));
      const reader = new FileReader();
      this.fileNameFullsize = file.name;
      this.fileData = formData;
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.contentSrc = reader.result;
      };

    } else {
      swal.fire({
        title: 'Attention',
        text: 'Fichier trop large. La taille maximal est 5mb.',
        type: 'error',
        confirmButtonText: 'Ok',
      });
    }
  }
  deleteImage(contentId): any {
    if (!contentId) {
      this.contentSrc = '';
      this.fileNameFullsize = '';
      this.fileData = null;
    } else {
      this.pilotInfoService.requestDeleteImage(this.dealership, this.contentDb.publicId).subscribe(res => {
        this.contentSrc = '';
        this.fileNameFullsize = '';
        this.fileData = null;
        swal.fire({
          title: 'Supprimé',
          text: 'L\'image a été supprimé avec succès.',
          type: 'success',
          confirmButtonText: 'Ok',
        });
      }, err => {
        swal.fire({
          title: 'Attention',
          text: 'Un problème est survenu lors de la suppression de l\'image, veuillez réessayer ultérieurement.',
          type: 'error',
          confirmButtonText: 'Ok',
        });
      });
    }
  }
  getImage(): any {
      this.pilotInfoService.requestGetImage(this.dealership, this.contentDb.publicId).subscribe(res => {
        if (res.base64) {
          this.contentSrc = res.base64;
        }
        //this.fileNameFullsize = '';
        //this.fileData = null;
      });
  }
  onCreate(): void {
    if (this.errorMessage != '') return null;

    const body = {
      value: this.value,
      startAt: this.startAt,
      endAt: this.endAt,
      dealership: this.dealership,
      brand: this.brand,
    };

    if (this.elementId) {
      this.pilotInfoService.updateContent(body, this.elementId).subscribe(res => {
        if (this.fileData) {
          this.submitUploadImage(this.fileData, this.contentDb.publicId);
        }
        this.onSuccess('update');
      }, error => (err => {
        this.onError();
      }));
    } else {
      this.pilotInfoService.createContent(body).subscribe(res => {
        if (this.fileData) {
          this.submitUploadImage(this.fileData, res);
        }
        this.onSuccess('create');
      }, error => (err => {
        this.onError();
      }));
    }
  }
  submitUploadImage(formData, publicId): void {

    let existing = formData.get('info');
    existing = existing ? JSON.parse(existing) : {};
    existing.publicId = publicId;
    formData.set('info', JSON.stringify(existing));

    this.pilotInfoService.requestUploadImage(formData).subscribe(res => {
      // swal.fire({
      //   title: 'Fichier enregistré',
      //   text: 'Le fichier a été importé avec succès.',
      //   type: 'success',
      //   confirmButtonText: 'Ok',
      // });
    }, err => {
      swal.fire({
        title: 'Attention',
        text: 'Un problème est survenu lors de l\'importation du fichier, veuillez réessayer ultérieurement.',
        type: 'error',
        confirmButtonText: 'Ok',
      });
    });
  }
  onCancel(): void {
    this.route.navigate(['/gestion-pilot-info']);
  }
  onSuccess(type): void {
    swal.fire({
      title: 'Success!',
      text: 'Le contenu a bien été ' + (type == 'create' ? 'créé' : 'modifié'),
      type: 'success',
      //showCancelButton: true,
      //cancelButtonText: 'Retourner vers la liste',
      confirmButtonText: 'Ok'
    }).then((result) => {
      this.route.navigate(['/gestion-pilot-info']);
      // if (result.dismiss) {
      //
      // }
      //
    });
  }
  onError(): void {
    swal.fire({
      title: 'Oops...!',
      text: 'Une erreur est surnevue lors de l\'enregistrement..',
      type: 'error',
      confirmButtonText: 'Ok'
    });
  }
}
